export var isProduction = process.env.NODE_ENV === 'production';
export var isDevelopment = process.env.NODE_ENV === 'development';
export var isInCypressTestMode = Boolean(window.Cypress);
var LocalAPIOverrideStorageKey = 'LOCAL_API_OVERRIDE';
var hostname = window.location.hostname;
export var isLocalhost = hostname === 'localhost';
